<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div><el-divider >添加成绩</el-divider></div>
        <div style="padding: 10px;">
          <div style="padding: 10px;">
            <el-form ref="editForm" :model="editForm" label-width="80px" size="mini">
              <el-form-item label="姓名" >
                <el-input v-model="editForm.student_name" placeholder="输入学生的姓名,如:王小小"></el-input>
              </el-form-item>
              <el-form-item label="学号">
                <el-input v-model="editForm.student_num" placeholder="输入学生的学号,查询使用,可以自行设定,不得少于4位,如:95312"  ></el-input>
              </el-form-item>
              <div>
              <el-form-item label="成绩">
                <el-input v-model="editForm.score" placeholder="输入考试成绩,如:131.5,或 A,B等" ></el-input>
              </el-form-item>
              </div>

              <el-form-item size="large">
                <el-button size="small" type="primary" @click="saveReturn">保存返回</el-button>
                <el-button size="small" type="primary" @click="saveAndNew">保存再加一条</el-button>
                <el-button @click="backToDetail">返回</el-button>
              </el-form-item>
            </el-form>
          </div>

        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        exam_id: '',
        editForm: {
          student_name: '',
          student_num: '',
          score: '',
          course: ''
        }
      }
    },
    created() {
      this.exam_id = this.$route.params.id
      this.course = this.$route.params.course
    },
    methods: {
      saveReturn() {
        this.saveData('添加成功！', 'exam_detail', this.exam_id)
      },
      backToDetail() {
        let that = this
        this.$router.push({
          name: 'exam_detail',
          params: {
            id: that.exam_id,
            course: that.course
          }
        })
      },
      saveData(msg, routeName, examID) {
        // 数据校验
        if (this.editForm.student_name === '') {
           this.$message.error('请输入学生姓名')
           return
        }
        if (this.editForm.student_num === '') {
           this.$message.error('请输入学号，查询使用，可以自行设置，不得少于4位数字')
           return
        }

        if (this.editForm.student_num.length < 4) {
           this.$message.error('学号必须是4位或者更多')
           return
        }

         if (this.editForm.score === '') {
           this.$message.error('请输入成绩')
           return
        }

        let that = this
        var requestUrl = '/score/web/_score_add_save.jsp'
        this.axios.get(requestUrl, {
            params: {
              exam_id: that.exam_id,
              student_name: that.editForm.student_name,
              student_num: that.editForm.student_num,
              score: that.editForm.score
            }
          }).then(function(response) {
            console.log(response.data.result)
            var result = response.data.result
            if (result === '0') {
              that.$router.push({
                name: routeName,
                params: {
                  id: examID,
                  course: that.course
                }
              })

              that.editForm.student_name = ''
              that.editForm.student_num = ''
              that.editForm.score = ''

              that.$message('添加成功！')
            } else {
              that.$message.error('保存失败！')
            }
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      saveAndNew() {
        this.saveData('添加成功,再添加一条吧！', 'score_add', this.exam_id)
      }
    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }
</style>



// WEBPACK FOOTER //
// src/components/score_add.vue